<div class="container single-view" id="add-shipment">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/shipments" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'SHIPMENTS.BTN_BACK_TO_SHIPMENT' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="add-shipment-title" class="section-title">{{ 'SHIPMENT_CREATE.TITLE' | translate }}</h1>
          <p data-testid="edit-shipment-subtitle" class="section-subtitle mt-1 text-base">{{ 'SHIPMENT_CREATE.SUBTITLE' | translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <form class="mt-0" [formGroup]="shipmentForm" data-testid="add-shipment-form">
              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 data-testid="edit-shipment-details" class="border-b pb-3">{{ 'SHIPMENT_CREATE.SHIPMENT_DETAILS' | translate }}</h2>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-shipment-field-reference" class="block text-sm" for="reference">{{ 'SHIPMENT_CREATE.SHIPMENT_REFERENCE' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-shipment-reference-input" type="text" id="reference" formControlName="reference" autocomplete="off">
                  @if (shipmentForm.get('reference')?.invalid && shipmentForm.get('reference')?.touched) {
                    <small data-testid="reference-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-shipment-field-retailer" class="block text-sm" for="retailerId">{{ 'SHIPMENT_CREATE.RETAILER' | translate }} <i class="icon-required-field"></i></label>
                  <app-custom-dropdown
                    data-testid="retailer"
                    [placeholder]="'SALE_UPDATE.SELECT_RETAILER' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="combosData['retailers'].rowsPerPageOption || 5"
                    [totalCount]="combosData['retailers'].totalRecords"
                    [totalPages]="getComboTotalPages('retailers')"
                    [options]="combosData['retailers'].list"
                    formControlName="retailerId"
                    (onLazyLoad)="onLazyLoadComboData('retailers', $event)">
                  </app-custom-dropdown>
                  @if (shipmentForm.get('retailerId')?.invalid && shipmentForm.get('retailerId')?.touched) {
                    <small data-testid="retailer-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-shipment-field-origin" class="block text-sm" for="originId">{{ 'SHIPMENT_CREATE.SHIPMENT_ORIGIN' | translate }} <i class="icon-required-field"></i></label>
                  <app-custom-dropdown
                    data-testid="origin"
                    [placeholder]="'SALE_UPDATE.SELECT_RETAILER' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="combosData['origins'].rowsPerPageOption || 5"
                    [totalCount]="combosData['origins'].totalRecords"
                    [totalPages]="getComboTotalPages('origins')"
                    [options]="combosData['origins'].list"
                    formControlName="originId"
                    (onLazyLoad)="onLazyLoadComboData('origins', $event)">
                  </app-custom-dropdown>
                  @if (shipmentForm.get('originId')?.invalid && shipmentForm.get('originId')?.touched) {
                    <small data-testid="origin-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-shipment-field-destination" class="block text-sm" for="destinationId">{{ 'SHIPMENT_CREATE.SHIPMENT_DESTINATION' | translate }} <i class="icon-required-field"></i></label>
                  <app-custom-dropdown
                    data-testid="destination"
                    [placeholder]="'SALE_UPDATE.SELECT_RETAILER' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="combosData['destinations'].rowsPerPageOption || 5"
                    [totalCount]="combosData['destinations'].totalRecords"
                    [totalPages]="getComboTotalPages('destinations')"
                    [options]="combosData['destinations'].list"
                    formControlName="destinationId"
                    (onLazyLoad)="onLazyLoadComboData('destinations', $event)">
                  </app-custom-dropdown>
                  @if (shipmentForm.get('destinationId')?.invalid && shipmentForm.get('destinationId')?.touched) {
                    <small data-testid="destination-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12">
                  <label data-testid="add-shipment-field-comments" class="block text-sm" for="comment">{{ 'SHIPMENT_CREATE.COMMENTS' | translate }}</label>
                  <textarea data-testid="add-shipment-comments-input" type="text" id="comment" formControlName="comment" autocomplete="off"></textarea>
                  @if (shipmentForm.get('comment')?.invalid && shipmentForm.get('comment')?.touched) {
                    <small data-testid="comments-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
              </div>
              <div class="row">
                <div class="col-12 mt-6 mb-4 pt-8 border-t">
                  <div class="flex items-center justify-end gap-3">
                    <button data-testid="add-shipment-create-shipment-button" class="btn primary-btn" [disabled]="shipmentForm.invalid" (click)="submitForm()">
                      {{ 'SHIPMENT_CREATE.BTN_ADD_NEW_SHIPMENT' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
